import GenerateProductLoadingModal from "./generateProductLoadingModal.container";

export default GenerateProductLoadingModal